
import React, { useState, useEffect } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import PollList from '@/components/group/PollList';
import ChatPanel from '@/components/group/ChatPanel';
import { useAuth } from '@/contexts/auth';
import { Trip } from '@/types/itinerary';

interface TripContextType {
  trip: Trip;
  isAuthorized: boolean;
}

const Group: React.FC = () => {
  const { user } = useAuth();
  const { tripId: tripIdFromParams } = useParams<{ tripId: string }>();
  const context = useOutletContext<TripContextType | null>();
  const [activeTab, setActiveTab] = useState<string>("all");
  
  // Use trip ID from context if available, otherwise fallback to URL params
  const tripId = context?.trip?.id || tripIdFromParams || "123e4567-e89b-12d3-a456-426614174000";

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-[#0A3D62] font-poppins mb-4">Chat & Polls</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Chat Section */}
        <div>
          <Card className="p-6 h-full">
            <h3 className="text-xl font-semibold text-[#0A3D62] mb-4">Group Chat</h3>
            <ChatPanel tripId={tripId} />
          </Card>
        </div>

        {/* Poll Section */}
        <div className="space-y-6">
          <Card className="p-6">
            <h3 className="text-xl font-semibold text-[#0A3D62] mb-4">Polls</h3>
            <p className="text-gray-600 mb-4">
              Create and vote on polls to make group decisions easier.
            </p>
            <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsList className="bg-muted/50 grid grid-cols-2 mb-4">
                <TabsTrigger value="all" className="data-[state=active]:bg-white data-[state=active]:shadow-sm">All Polls</TabsTrigger>
                <TabsTrigger value="active" className="data-[state=active]:bg-white data-[state=active]:shadow-sm">Active Polls</TabsTrigger>
              </TabsList>
              <TabsContent value="all" className="mt-0">
                <PollList tripId={tripId} showClosed={true} />
              </TabsContent>
              <TabsContent value="active" className="mt-0">
                <PollList tripId={tripId} showClosed={false} />
              </TabsContent>
            </Tabs>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Group;
